import React from "react";
import InfoCard from "src/components/InfoCard";
import Layout from "src/components/Layout";

const FitnessForWorkAssessment: React.FC = () => {
  return (
    <Layout>
      <InfoCard
        title={
          "Fitness For Work Assessment/Pre-Employment & Annual Checks/Sickness Absence Management"
        }
        zeroPadding
      >
        <ul
          style={{
            color: "#000866",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          <li>ABS Medical Fitness Certificate</li>
          <li>ADNOC Medical Fitness Certificate</li>
          <li>DOLPHIN ENERGY Medical Fitness Certificate</li>
          <li>EBM Medical Fitness Certificate</li>
          <li>KBR Medical Fitness Certificate</li>
          <li>PGS Medical Fitness Certificate</li>
          <li>SAIPEM Medical Fitness Certificate</li>
          <li>SCHLUMBERGER Medical Fitness Certificate</li>
          <li>SHELL Medical Fitness Certificate</li>
          <li>TIDEWATER Medical Fitness Certificate</li>
          <li>Qatar Energy LNG Medical Certificate</li>
          <li>Qatar Energy Medical Certificate</li>
          <li>Medilink Medical Certificate “eni”</li>
          <li>MSC Medical Certificate</li>
          <li>Seachef Medical Certificate</li>
          <li>CMA-CGM Medical Certificate</li>
          <li>Technip Medical Certificate</li>
          <li>NPCC Medical Certificate</li>
          <li>Wood Medical Certificate</li>
          <li>TOTAL Medical Certificate</li>
          <li>Brunie Darussalam Medical Certificate</li>
        </ul>
      </InfoCard>
    </Layout>
  );
};

export default FitnessForWorkAssessment;
